import { NavLink } from "react-router-dom";
import Breadcumbs from "../../components/Breadcumbs";
import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import BlockImageCabecera from "../../components/BlockImageCabecera";

import ConectUs from "../../components/ConectUs";
import Notification from "../../components/Notification";
import BlockLeftImage from "../../components/BlockLeftImage";
import Quote from "../../components/Quote";
import calendario from "../../img/iconsoferta/calendario.png";
import modalidad from "../../img/iconsoferta/modalidad.png";
import titulo from "../../img/iconsoferta/titulo.png";
import sale from "../../img/iconsoferta/sale.png";

import inicio from "../../img/iconsoferta/inicio.png";
import { DistanciaNuevosFixed } from "../../components/Pasos";
import Block5Columns from "../../components/Block5Columns";
import Block3Columns from "../../components/Block3Columns";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockRightImage from "../../components/BlockRightImage";
import EnLineaPagos from "../../components/Enlineapagos";
import AccordionFromHtml from "../../components/Accordionfromhtml";
import TecPagos from "../../components/TecPagos";
import Modalidad from "../../components/posgrados/Modalidad";
import InfoCards from "../../components/posgrados/InfoCards";
const url = "https://tec.utpl.edu.ec";
function TecContabilidad() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            <div className="relative">
              <BlockImageCabecera
                src={url + item.field_imagen_template}
                title={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_texto_portada,
                      }}
                    />
                  </>
                }
              ></BlockImageCabecera>
              <DistanciaNuevosFixed></DistanciaNuevosFixed>
            </div>
            <div className="lightbluebg">
              <Breadcumbs
                content={
                  <>
                  
                  
                    <NavLink to="/tecnologia-contabilidad">
                      Tecnología Superior en Contabilidad y Asesoría Tributaria
                    </NavLink>
                  </>
                }
              ></Breadcumbs>
                    <InfoCards
                titulo={item.field_titulo}
                inversion={item.field_costo}
                inicio={item.field_fecha_inicio}
                duracion={item.field_duracion}
                modalidad={
                  <>
                    <Modalidad value={item.field_modalidad}></Modalidad>
                  </>
                }
                resolucion={item.field_carrera_resolucion}
              ></InfoCards>

            
            </div>
                 <a href="https://utpl.edu.ec/validacion-tecnologias">
              {" "}
              <img src="https://www.utpl.edu.ec/carreras/sites/default/files/banner-rec.png"></img>{" "}
            </a>
            {/* <div className="margin">
              <Block3Columns
                col1={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_descripcion_tec,
                      }}
                    />{" "}
                  </>
                }
                col2={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_descripcion1,
                      }}
                    />{" "}
                  </>
                }
                col3={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_descripcion2,
                      }}
                    />
                  </>
                }
              ></Block3Columns>
            </div> */}
            {item.field_atributo1 && item.field_atributo1.trim() !== "" && (
              <Quote
                content={
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_atributo1,
                    }}
                  />
                }
              />
            )}

            <div id="perfil">
              <BlockBackgroundImage
                src={url + item.field_imagen_perfil_profesional}
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_perfil_profesional,
                    }}
                  />
                }
              ></BlockBackgroundImage>
            </div>
            <div className="layout8 padding" id="malla">
              <div
                className="width700"
                dangerouslySetInnerHTML={{
                  __html: item.field_malla_titulo,
                }}
              />
              <div className="layout6">
                <AccordionFromHtml htmlContent={item.field_malla}>
                  {" "}
                </AccordionFromHtml>
              </div>
            </div>
            <div className="lightbluebg padding">
              <BlockRightImage
                src={url + item.field_imagen1}
                content={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque1,
                      }}
                    />
                  </>
                }
              ></BlockRightImage>
            </div>
            <div className="padding" id="descuentos">
              <TecPagos></TecPagos>
            </div>
            {item.field_atributo2 && item.field_atributo2.trim() !== "" && (
              <Quote
                content={
                  <p
                    dangerouslySetInnerHTML={{
                      __html: item.field_atributo2,
                    }}
                  />
                }
              />
            )}
            <div className="icon300 padding lightbluebg">
              <BlockRightImage
                src={url + item.field_imagen_docente}
                content={
                  <>
                    <p className="iconsize20">📣</p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_texto_docente,
                      }}
                    />
                  </>
                }
              ></BlockRightImage>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://tec.utpl.edu.ec/tec-contabilidad-online">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>

      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default TecContabilidad;
